module.exports = __webpack_public_path__ + "static/img/ku-education.4d91e56.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/ku-education.jpg
// module id = SBOf
// module chunks = 0